
import React from 'react'
import { BrowserRouter as Router } from 'react-router-dom'
import { Provider } from 'react-redux'
import { configureStore } from '../../store'
import App from './App'
import ModalErrorNoSuccess from '../components/features/share/modal/modalErrorNoSuccess'
import ErrorBoundary from '../components/features/share/ErrorBoundary'
import '../components/scss/index.scss'

const store = configureStore()


export default () => (
    <Provider store={store}>
        <Router>
            <React.Fragment>
                <ErrorBoundary>
                    <App />
                    <ModalErrorNoSuccess />
                </ErrorBoundary>
            </React.Fragment>
        </Router>
    </Provider>
)


// WEBPACK FOOTER //
// ./src/app/routes/Root.js